import Vue from 'vue';
import ArrayViewer from './FormElementViewers/ArrayViewer';
import AudioViewer from './FormElementViewers/AudioViewer';
import CheckboxViewer from './FormElementViewers/CheckboxViewer';
import DateViewer from './FormElementViewers/DateViewer';
import FileViewer from './FormElementViewers/FileViewer';
import FormGroupViewer from './FormElementViewers/FormGroupViewer';
import ImageViewer from './FormElementViewers/ImageViewer';
import LocationViewer from './FormElementViewers/LocationViewer';
import PageBreakViewer from './FormElementViewers/PageBreakViewer';
import ScaleViewer from './FormElementViewers/ScaleViewer';
import TextViewer from './FormElementViewers/TextViewer';

export default Vue.extend({
  name: 'FormSubElementView',
  functional: true,
  props: {
    type: { type: String, required: true }
  },
  render: function (h, context) {
    function appropriateComponent () {
      const type = context.props.type;

      if (['multi_select', 'prioritize'].indexOf(type) !== -1) return ArrayViewer;
      else if (type === 'audio') return AudioViewer;
      else if (type === 'checkbox') return CheckboxViewer;
      else if (type === 'date') return DateViewer;
      else if (type === 'file') return FileViewer;
      else if (type === 'form_group') return FormGroupViewer;
      else if (['image', 'scribble', 'signature'].indexOf(type) !== -1) return ImageViewer;
      else if (type === 'location') return LocationViewer;
      else if (type === 'page_break') return PageBreakViewer;
      else if (type === 'scale') return ScaleViewer;
      else if (['barcode', 'select', 'input'].indexOf(type) !== -1) return TextViewer;

      return null;
    }

    context.data.attrs.type = context.props.type;

    const component = appropriateComponent();

    if (component) {
      return h(component, context.data, context.children);
    } else {
      return null;
    }
  }
});
